export const PROFILE_IMAGE_FALLBACK = "/fallback-profile.svg";
export const BANNER_IMAGE_FALLBACK = "/fallback-banner.svg";

const firstImage = (...values) => values.find((value) => typeof value === "string" && value.trim()) || "";

export function getProfileImage(profile = {}) {
  return firstImage(profile.avatar, profile.photo) || PROFILE_IMAGE_FALLBACK;
}

export function getBannerImage(profile = {}) {
  return firstImage(profile.hero, profile.bannerUrl, profile.image) || BANNER_IMAGE_FALLBACK;
}

export function imageFallbackHandler(fallback) {
  return (event) => {
    if (event.currentTarget.src.endsWith(fallback)) return;
    event.currentTarget.src = fallback;
  };
}
